export function FloatingDecorations() {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden">
      {/* Top decorations */}
      <div className="absolute top-20 left-10 w-16 h-16 border-2 border-black/10 rotate-12 animate-pulse" />
      <div className="absolute top-32 right-20 w-8 h-8 bg-black/5 rounded-full animate-bounce" style={{ animationDelay: '1s' }} />
      <div className="absolute top-40 left-1/3 w-12 h-12 border-2 border-black/10 rounded-full animate-pulse" style={{ animationDelay: '2s' }} />
      
      {/* Middle decorations */}
      <div className="absolute top-1/2 left-5 w-6 h-6 bg-black/5 rotate-45 animate-bounce" style={{ animationDelay: '0.5s' }} />
      <div className="absolute top-1/2 right-10 w-10 h-10 border-2 border-black/10 rotate-12 animate-pulse" style={{ animationDelay: '1.5s' }} />
      
      {/* Bottom decorations */}
      <div className="absolute bottom-20 left-1/4 w-14 h-14 border-2 border-black/10 rotate-45 animate-pulse" style={{ animationDelay: '3s' }} />
      <div className="absolute bottom-40 right-1/3 w-8 h-8 bg-black/5 animate-bounce" style={{ animationDelay: '2.5s' }} />
    </div>
  );
}

export function GridPattern() {
  return (
    <div className="absolute inset-0 opacity-5 pointer-events-none">
      <div 
        className="w-full h-full" 
        style={{
          backgroundImage: `
            linear-gradient(to right, #000 1px, transparent 1px),
            linear-gradient(to bottom, #000 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px'
        }}
      />
    </div>
  );
}